import * as React from 'react';
import { useApi } from '../../Api/useApi';
import { IfcTreeNode } from './IfcTreeNode';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { Palette, PanoramaVerticalSelect, RemoveCircle, Visibility, VisibilityOff } from '@mui/icons-material';

import { ModelInfo } from '../Models/ModelInfo';
import { ElementInfo } from '../Models/ElementInfoModel';
import { ModelRycApiClient } from '../../Api/ApiServer';
import { useParams } from 'react-router';


export interface IModelTreeProps {
    modelIds: ModelInfo[];
    onSelect: (nodes: ElementInfo[]) => void;
    onIsolate: (nodes: ElementInfo[]) => void;
    onHide: (nodes: ElementInfo[]) => void;
    resetElementsHideIsolate?: boolean;
    authorized: boolean;
}
interface TreeNodeProps {
    node: IfcTreeNode;
    modelIds: ModelInfo[];
    onSelect: (nnodes: ElementInfo[]) => void;
    onIsolate: (nodes: ElementInfo[]) => void;
    onHide: (nodes: ElementInfo[]) => void;
    isolatedElements?: ElementInfo[];
    setIsolatedElements?: (ids: ElementInfo[]) => void;
}
const getModelGuidFromId = (id: number, modelIds: ModelInfo[]) => {
    return modelIds.find((modelId) => modelId.modelId === id)?.fragmentId;
}
const getModelIdFromGuid = (guid: string | undefined, modelIds: ModelInfo[]) => {
    if (!guid) return -1;
    return modelIds.find((modelId) => modelId.fragmentId === guid)?.modelId;
}
export default function ModelTree(props: IModelTreeProps) {
    const { authorizedApi, unauthorizedApi } = useApi(ModelRycApiClient);
    const { modelIds, onHide, onIsolate, onSelect, resetElementsHideIsolate } = props;
    const [tree, setTree] = React.useState<{ modelId: any, data: IfcTreeNode[] }[]>([]);
    const params = useParams();
    const refreshTree = React.useCallback(() => {
        if (props.authorized) {
            if (!authorizedApi) return;
            if (params['id'] === undefined || params['id'] === null) return;
            authorizedApi.getModelTreesForProject(Number(params.id)).then((data) => {
                console.log('data', data);
                if (data) {
                    setTree(data.modelTrees?.map((d) => ({ modelId: d.modelId, data: JSON.parse(d.ifcTree ?? '') })) ?? []);
                }
            });
        }
        else if (params.code) {
            unauthorizedApi.getModelTreesForProjectClient(params.code).then((data) => {
                if (data) {
                    setTree(data.modelTrees?.map((d) => ({ modelId: d.modelId, data: JSON.parse(d.ifcTree ?? '') })) ?? []);
                }
            });
        }

    }, [authorizedApi, params, props.authorized, unauthorizedApi]);

    React.useEffect(() => {
        if (resetElementsHideIsolate) {
            setHiddenElements([]);
            setIsolatedElements([]);
        }
    }, [resetElementsHideIsolate])
    React.useEffect(() => {
        console.log(tree, 'trree');
    }, [tree])
    React.useEffect(() => {
        refreshTree();
    }, [refreshTree]);
    const [isolatedElements, setIsolatedElements] = React.useState<ElementInfo[]>([]);
    const [hiddenElements, setHiddenElements] = React.useState<ElementInfo[]>([]);
    return (
        <div className='draggable-window-content'>

            {tree.length > 0 && tree.map((modelTree) => {
                return modelTree.data.map((rootNode) =>
                    <ModelTreeItem
                        modelIds={modelIds}
                        isolatedElements={isolatedElements}
                        setIsolatedElements={setIsolatedElements}
                        onIsolate={onIsolate} onSelect={onSelect}
                        onHide={onHide}
                        key={rootNode.data.expressID + '' + rootNode.data.modelID}
                        node={rootNode} />
                )
            })}
        </div>
    );
}
const ModelTreeItem: React.FC<TreeNodeProps> = ({ node, onHide, onIsolate, onSelect, isolatedElements, setIsolatedElements, modelIds }) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleToggle = () => {
        setExpanded((prev) => !prev);
    };
    const handleAction = (action: (node: ElementInfo[]) => void) => {
        if (!node.children || node.children.length === 0) {
            if (node.data.expressID)
                action([{ expressId: node.data.expressID, modelId: getModelIdFromGuid(node.data.modelID, modelIds) ?? -1 }]);
        } else {
            const leafIds = getLeafIds(node);
            console.log('leaf ids', leafIds);
            action(leafIds);

        }
    };

    const getLeafIds = (node: IfcTreeNode, leafIds: ElementInfo[] = []): ElementInfo[] => {
        if (!node.children || node.children.length === 0) {
            if (node.data.expressID)
                leafIds.push({ expressId: node.data.expressID, modelId: getModelIdFromGuid(node.data.modelID, modelIds) ?? -1 });
        } else {
            node.children.forEach(child => getLeafIds(child, leafIds));
        }
        return leafIds;
    };

    // const findNodeById = (node: IfcTreeNode, id: number): IfcTreeNode | null => {
    //     if (node.data.expressID === id) return node;
    //     if (node.children) {
    //         for (const child of node.children) {
    //             const result = findNodeById(child, id);
    //             if (result) return result;
    //         }
    //     }
    //     return null;
    // };

    return (
        <Box sx={{ ml: 2, mt: 1 }}>
            <Box display="flex" alignItems="center">

                {node.children ? (
                    <IconButton size="small" onClick={handleToggle}>
                        {expanded ? '-' : '+'}
                    </IconButton>
                ) : (
                    <Box sx={{ width: '24px' }} />
                )}
                <Typography variant="body1">{node.data.Name ?? node.data.Entity}</Typography>
                <Button onClick={() => handleAction(onSelect)}><Palette /></Button>
                {isolatedElements?.find(x => x.modelId === getModelIdFromGuid(node.data.modelID, modelIds) && x.expressId === node.data.expressID) === undefined && <Button onClick={() => handleAction((ids) => { onIsolate(ids); })}><Visibility /></Button>}
                {isolatedElements?.find(x => x.modelId === getModelIdFromGuid(node.data.modelID, modelIds) && x.expressId === node.data.expressID) !== undefined && <Button onClick={() => handleAction((ids) => { onIsolate(ids); })}><VisibilityOff /></Button>}
                <Button onClick={() => handleAction(onHide)}><RemoveCircle /></Button>


            </Box>

            {expanded && node.children && (
                <Box sx={{ pl: 2 }}>
                    {node.children.map((childNode: any) => (
                        <ModelTreeItem
                            modelIds={modelIds}
                            isolatedElements={isolatedElements}
                            setIsolatedElements={setIsolatedElements}
                            onSelect={onSelect}
                            onHide={onHide}
                            onIsolate={onIsolate}
                            key={childNode.data.expressID + '' + childNode.data.modelID}
                            node={childNode} />
                    ))}
                </Box>
            )}
        </Box>
    );
};